// DEPRECATED compatibility wrapper — do not add call sites. Use <Tag> directly.
// Kept so the existing Badge importers keep compiling during the migration.
import type { ReactNode } from 'react';
import Tag, { type TagTone } from './Tag';

export type BadgeVariant =
  | 'community'
  | 'separate'
  | 'mixed'
  | 'unknown'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info';

export interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}

const VARIANT_TO_TONE: Record<BadgeVariant, TagTone> = {
  community: 'community',
  separate: 'separate',
  mixed: 'mixed',
  unknown: 'unknown',
  success: 'good',
  warning: 'warn',
  danger: 'danger',
  info: 'info',
};

export default function Badge({ variant = 'unknown', children, className = '' }: BadgeProps) {
  return (
    <Tag tone={VARIANT_TO_TONE[variant]} size="md" className={className}>
      {children}
    </Tag>
  );
}
